import React from "react";

// THT合同会社サイト 共通データ
export const newsArticles = [
  { id: 1, date: "2026.07.15", title: "2025年6月にMTT大会を開催し、150人の参加者が集まりました" },
  { id: 2, date: "2026.07.15", title: "2025年2月に土日だけ体操教室の第1店舗、富山県堀川店が開校しました" },
  { id: 3, date: "2026.07.14", title: "2025年8月に平日体幹事業を開始しました" },
  { id: 4, date: "2026.07.13", title: "土日だけダンス教室 開校しました" },
];

export const guidelines = [
  {
    label: "Mission",
    sub: "存在理由",
    title: "好奇心のタネをまく",
    body: "人はそれぞれ、違うスピードで、違う形で育っていきます。\n早く芽が出る子もいれば、ゆっくり時間をかけて根を張る子もいます。\n得意なことがある子もいれば、まだ見つかっていないだけの子もいます。\n\n私たちが大切にしているのは、その違いに優劣をつけないことです。\n「勉強についていけない」「みんなと同じペースで進めない」\nそんな理由で、成長のきっかけを諦めてほしくない。\n\n私たちは、一人ひとりの「今」に種をまき、\nそれぞれのペースで、それぞれの形で育っていける場所をつくります。\n\nできる・できないで測るのではなく、\n「やってみたい」という気持ちが、そのまま次の一歩になる。\nそんな場所を、私たちはつくり続けます。",
  },
  {
    label: "Vision",
    sub: "どんな未来・状態を目指すか",
    title: "誰もが成長できる場所がある",
    body: "好奇心のタネは、どんな子の中にもあります。\nでも、そのタネが芽を出すには、まける土と、育つための場所が必要です。\n住んでいる町や家庭の事情によって、その場所に出会えない子もいます。\n\n私たちは、生まれた場所や環境で成長のチャンスが決まってしまう地域にしたくありません。\n「近くに通える場所がない」そんな理由で、芽を出せないタネをなくしたい。\n\nだから私たちは、地域のあちこちに、気軽に立ち寄れる場所を広げていきます。\n学校でも家でもない、もうひとつの居場所として。\nそこで出会う人やできごとが、新しい好奇心のタネになっていきます。\n\nいつでも、どこに住んでいても、誰もが成長できる場所がある。\nそんな地域を、私たちはみなさんと一緒に育てていきます。",
  },
  {
    label: "Value",
    sub: "どう行動するか",
    title: "「できた」を、一緒につくる人へ。",
    body: "得意なことも、苦手なことも、成長のスピードも、子どもによって違います。\nその違いを否定せず、一人ひとりの「今」に寄り添える人。\n\n「できなかったこと」が「できた」に変わる瞬間を、\n子どもと同じ目線で喜べる人。\n\n私たちが求めているのは、そんな人です。\n専門的なスキルや経験がなくても構いません。\n\n子どもの成長を、心から楽しめること。\nそれが何よりの資格です。",
  },
];

export const businesses = [
  {
    title: "スポーツクラブ",
    catch: "ほめて伸ばし「できた」で好奇心をさかせる",
    text: "体操・体幹・陸上・チアリーディングなど、得意・不得意に関係なく誰もが自分のペースで体を動かせるスポーツクラブです。小さな「できた」を積み重ね、運動以外の挑戦にもつなげます。",
  },
  {
    title: "MTT大会・進級テスト",
    catch: "がんばりを形にして、次の「できた」へつなげる",
    text: "進級テストで成長を目に見える形にし、大会では仲間と挑戦し、応援し合います。結果だけでなく、そこまでの挑戦をしっかりほめます。",
  },
  {
    title: "学習塾",
    catch: "「わかった」を積み重ねて、学ぶ楽しさを咲かせる",
    text: "デジタル教材「天神」を使い、一人ひとりの理解度に合わせて、つまずいたところから学び直します。自分から学ぶ力と好奇心を育てます。",
  },
];

export const recruitInfo = [
  { label: "雇用形態", value: "正社員" },
  { label: "勤務時間", value: "9:00〜18:00（8時間）" },
  { label: "休日", value: "年間休日120日・週休2日制\n1月/5月/8月/12月は1週間休暇あり" },
  { label: "福利厚生", value: "雇用保険・労災・健康保険・厚生年金" },
];

export const companyInfo = [
  { label: "会社名", value: "THT合同会社" },
  { label: "設立", value: "2024年8月" },
  { label: "所在地", value: "〒920-1155\n石川県金沢市田上本町4丁目40番地" },
  { label: "役員", value: "代表　高田知己\n役員　高田隆徳\n役員　高田治吉" },
];

export const InfoTable = ({ rows }: { rows: { label: string; value: string }[] }) => (
  <dl className="info-table">
    {rows.map((r) => (
      <div key={r.label} className="info-row">
        <dt>{r.label}</dt>
        <dd>{r.value}</dd>
      </div>
    ))}
  </dl>
);

